import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterCheckboxList, { FilterListItem } from './FilterCheckboxList';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    actingBodyId: number;
}

function TagsList({ value, setValue, actingBodyId }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getOccurrenceTags() {
        try {
            setIsLoading(true);
            const tags = await dispatchService.getDropDownOccurrenceTags(actingBodyId);
            setItems(tags.map((tag) => ({ value: tag.id, label: tag.name, color: tag.color })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getOccurrenceTags();
        } else {
            setItems([]);
            setIsLoading(false);
        }
    }, [actingBodyId]);

    return <FilterCheckboxList items={items} value={value} setValue={setValue} renderBadge isLoading={isLoading} />;
}

export default TagsList;
